import sum from 'lodash/sum';

export const FeeType = {
  /** 建安费 */
  constructionFee: 'constructionFee',
  /** 设备费 */
  deviceFee: 'deviceFee',
  /** 其他费用 */
  otherFee: 'otherFee'
};

export const FeeSubType = {
  /** 项目建设用地费 */
  areaFee: 'areaFee',
  /** 项目建设管理费 */
  manageFee: 'manageFee',
  /** 生产准备费 */
  producePrepareFee: 'producePrepareFee',
  /** 勘察设计费 */
  designFee: 'designFee',
  /** 其他税费 */
  taxFee: 'taxFee'
};

export const FeeCompute = {
  powerProjectPrice: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (formData.powerProjectPrice * data.cap) / 10000;
    }
  },
  waterProjectPrice: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (formData.waterProjectPrice * data.cap) / 10000;
    }
  },
  auxiliaryProjectPrice: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (formData.auxiliaryProjectPrice * data.cap) / 10000;
    }
  },
  installProjectTurbinePrice: {
    type: FeeType.deviceFee,
    getFee({ formData, data }) {
      return (formData.installProjectTurbinePrice * data.cap) / 10;
    }
  },
  installProjectTurbineCoefficient: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (
        (formData.installProjectTurbineCoefficient *
          FeeCompute.installProjectTurbinePrice.getFee({ formData, data })) /
        100
      );
    }
  },
  installProjectTowerBarrelPrice: {
    type: FeeType.deviceFee,
    getFee({ formData, data }) {
      return formData.installProjectTowerBarrelPrice * data.tubeNum;
    }
  },
  installProjectTowerBarrelCoefficient: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (
        (formData.installProjectTowerBarrelCoefficient *
          FeeCompute.installProjectTowerBarrelPrice.getFee({
            formData,
            data
          })) /
        100
      );
    }
  },
  installProjectBoxPrice: {
    type: FeeType.deviceFee,
    getFee({ formData, data }) {
      return formData.installProjectBoxPrice * data.boxNum;
    }
  },
  installProjectBoxCoefficient: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (
        (formData.installProjectBoxCoefficient *
          FeeCompute.installProjectBoxPrice.getFee({ formData, data })) /
        100
      );
    }
  },
  installProjectLinePrice: {
    type: FeeType.deviceFee,
    getFee({ formData, data }) {
      return formData.installProjectLinePrice * data.wireLength;
    }
  },
  installProjectLineCoefficient: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (
        (formData.installProjectLineCoefficient *
          FeeCompute.installProjectLinePrice.getFee({ formData, data })) /
        100
      );
    }
  },
  installProjectBoosterPrice: {
    type: FeeType.deviceFee,
    getFee({ formData, data }) {
      return (formData.installProjectBoosterPrice * data.cap) / 10;
    }
  },
  installProjectBoosterCoefficient: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (
        (formData.installProjectBoosterCoefficient *
          FeeCompute.installProjectBoosterPrice.getFee({ formData, data })) /
        100
      );
    }
  },
  installProjectProtectionPrice: {
    type: FeeType.deviceFee,
    getFee({ formData, data }) {
      return (formData.installProjectProtectionPrice * data.cap) / 10;
    }
  },
  installProjectProtectionCoefficient: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (
        (formData.installProjectProtectionCoefficient *
          FeeCompute.installProjectProtectionPrice.getFee({ formData, data })) /
        100
      );
    }
  },
  installProjectOtherPrice: {
    type: FeeType.deviceFee,
    getFee({ formData, data }) {
      return (formData.installProjectOtherPrice * data.cap) / 10;
    }
  },
  installProjectOtherCoefficient: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (
        (formData.installProjectOtherCoefficient *
          FeeCompute.installProjectOtherPrice.getFee({ formData, data })) /
        100
      );
    }
  },
  windfarmProjectPrice: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (formData.windfarmProjectPrice * data.cap) / 10;
    }
  },
  boosterProjectPrice: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (formData.boosterProjectPrice * data.cap) / 10;
    }
  },
  housebuildersProjectPrice: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (formData.housebuildersProjectPrice * data.houseArea) / 10000;
    }
  },
  trafficProjectPrice: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return formData.trafficProjectPrice * data.roadLength;
    }
  },
  otherProjectPrice: {
    type: FeeType.constructionFee,
    getFee({ formData, data }) {
      return (formData.otherProjectPrice * data.cap) / 10;
    }
  },
  landAcquisitionProjectCycle: {
    type: FeeType.otherFee,
    subType: FeeSubType.areaFee,
    getFee({ formData, data }) {
      return (
        (formData.landAcquisitionProjectCycle *
          data.landAcquisitionArea *
          formData.landAcquisitionPrice) /
        10000
      );
    }
  },
  temporaryLandRentalCycle: {
    type: FeeType.otherFee,
    subType: FeeSubType.areaFee,
    getFee({ formData, data }) {
      return (
        (formData.temporaryLandRentalCycle *
          formData.temporaryLandRentalPrice *
          data.temporaryLandArea) /
        10000
      );
    }
  },
  migrationCompensationPrice: {
    type: FeeType.otherFee,
    subType: FeeSubType.areaFee,
    getFee({ formData }) {
      return (
        (formData.migrationCompensationPrice *
          formData.migrationCompensationArea) /
        10000
      );
    }
  },
  residualCleaningCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.areaFee,
    getFee(options) {
      const { formData } = options;
      return (
        ((FeeCompute.landAcquisitionProjectCycle.getFee(options) +
          FeeCompute.temporaryLandRentalCycle.getFee(options)) *
          formData.residualCleaningCoefficient) /
        100
      );
    }
  },
  projectPrePaymentCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.manageFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      const deviceFee = getTypeSumFee(FeeType.deviceFee, null, options);
      return (
        ((constructionFee + deviceFee) *
          formData.projectPrePaymentCoefficient) /
        100
      );
    }
  },
  projectConstructionManagementCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.manageFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      const deviceFee = getTypeSumFee(FeeType.deviceFee, null, options);
      return (
        ((constructionFee + deviceFee) *
          formData.projectConstructionManagementCoefficient) /
        100
      );
    }
  },
  projectConstructionSupervisionCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.manageFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      const deviceFee = getTypeSumFee(FeeType.deviceFee, null, options);
      return (
        ((constructionFee + deviceFee) *
          formData.projectConstructionSupervisionCoefficient) /
        100
      );
    }
  },
  projectConsultingServiceCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.manageFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      const deviceFee = getTypeSumFee(FeeType.deviceFee, null, options);
      return (
        ((constructionFee + deviceFee) *
          formData.projectConsultingServiceCoefficient) /
        100
      );
    }
  },
  projectTechnoEconomicsAssessCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.manageFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      const deviceFee = getTypeSumFee(FeeType.deviceFee, null, options);
      return (
        ((constructionFee + deviceFee) *
          formData.projectTechnoEconomicsAssessCoefficient) /
        100
      );
    }
  },
  projectInspectionCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.manageFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      const deviceFee = getTypeSumFee(FeeType.deviceFee, null, options);
      return (
        ((constructionFee + deviceFee) *
          formData.projectInspectionCoefficient) /
        100
      );
    }
  },
  projectInsuranceCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.manageFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      const deviceFee = getTypeSumFee(FeeType.deviceFee, null, options);
      return (
        ((constructionFee + deviceFee) * formData.projectInsuranceCoefficient) /
        100
      );
    }
  },
  personnelTrainEntranceCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.producePrepareFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      return (
        (constructionFee * formData.personnelTrainEntranceCoefficient) / 100
      );
    }
  },
  managementEquipmentPurchaseCostCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.producePrepareFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      return (
        (constructionFee *
          formData.managementEquipmentPurchaseCostCoefficient) /
        100
      );
    }
  },
  utensilProductionFurniturePurchaseCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.producePrepareFee,
    getFee(options) {
      const { formData } = options;
      const deviceFee = getTypeSumFee(FeeType.deviceFee, null, options);
      return (
        (deviceFee * formData.utensilProductionFurniturePurchaseCoefficient) /
        100
      );
    }
  },
  repairPiecePurchaseCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.producePrepareFee,
    getFee(options) {
      const { formData } = options;
      const deviceFee = getTypeSumFee(FeeType.deviceFee, null, options);
      return (deviceFee * formData.repairPiecePurchaseCoefficient) / 100;
    }
  },
  uniteRunningCoefficient: {
    type: FeeType.otherFee,
    subType: FeeSubType.producePrepareFee,
    getFee(options) {
      const { formData } = options;
      const constructionFee = getTypeSumFee(
        FeeType.constructionFee,
        null,
        options
      );
      return (constructionFee * formData.uniteRunningCoefficient) / 100;
    }
  },
  surveyPrice: {
    type: FeeType.otherFee,
    subType: FeeSubType.designFee,
    getFee({ formData, data }) {
      return (formData.surveyPrice * data.cap) / 10;
    }
  },
  designPrice: {
    type: FeeType.otherFee,
    subType: FeeSubType.designFee,
    getFee({ formData, data }) {
      return (formData.designPrice * data.cap) / 10;
    }
  },
  otherPrice: {
    type: FeeType.otherFee,
    subType: FeeSubType.designFee,
    getFee({ formData, data }) {
      return (formData.otherPrice * data.cap) / 10;
    }
  },
  otherTaxesPrice: {
    type: FeeType.otherFee,
    subType: FeeSubType.taxFee,
    getFee({ formData, data }) {
      return (formData.otherTaxesPrice * data.cap) / 10;
    }
  },
  basicReserveCoefficient: {
    // type: FeeType.constructionFee,
    getFee(options) {
      const { formData } = options;
      return (
        ((getTypeSumFee(FeeType.constructionFee, null, options) +
          getTypeSumFee(FeeType.deviceFee, null, options) +
          getTypeSumFee(FeeType.otherFee, null, options)) *
          formData.basicReserveCoefficient) /
        100
      );
    }
  },
  priceDifferenceReserveCoefficient: {
    // type: FeeType.constructionFee,
    getFee(options) {
      const { formData } = options;
      return (
        ((getTypeSumFee(FeeType.constructionFee, null, options) +
          getTypeSumFee(FeeType.deviceFee, null, options) +
          getTypeSumFee(FeeType.otherFee, null, options) +
          FeeCompute.basicReserveCoefficient.getFee(options)) *
          formData.priceDifferenceReserveCoefficient) /
        100
      );
    }
  },
  sendOutLineLengthPrice: {
    // type: FeeType.constructionFee,
    getFee({ formData }) {
      return formData.sendOutLineLengthPrice * formData.sendOutLineLength;
    }
  },
  capitalRatio: {
    getFee(options) {
      const { formData } = options;
      const staticInvest =
        getTypeSumFee(FeeType.constructionFee, null, options) +
        getTypeSumFee(FeeType.deviceFee, null, options) +
        getTypeSumFee(FeeType.otherFee, null, options) +
        FeeCompute.basicReserveCoefficient.getFee(options);
      const n = formData.constructionPeriod;
      const perYearFee = (staticInvest / n) * (1 - formData.capitalRatio / 100);
      const yearsFee = [];
      for (let i = 0; i < n; i++) {
        const capacityRatio = (n - i) / n;
        //（每年借款*（i - 1）+ 前n-1年建设期利息 +每年借款 / 2）*长期贷款利率*未并网容量比例
        const fee =
          (((perYearFee * i + sum(yearsFee) + perYearFee / 2) *
            formData.lendingRate) /
            100) *
          capacityRatio;
        yearsFee.push(fee);
      }
      return sum(yearsFee);
    }
  }
};

export function getTypeSumFee(type, subType, options) {
  const fee = Object.keys(FeeCompute).reduce((acc, key) => {
    if (
      !FeeCompute[key] ||
      (type && FeeCompute[key].type !== type) ||
      (subType && FeeCompute[key].subType !== subType)
    ) {
      return acc;
    }
    return acc + FeeCompute[key].getFee(options);
  }, 0);
  return fee;
}
